import {images} from './images'
import {CategoryDetails, Category, MetaTagsProps} from "@/types";
import EmojiEventsIcon from "@mui/icons-material/EmojiEvents";
import {
    Camera,
    Video,
    Palette,
} from 'lucide-react';
import {category as service1, createMetaTags as tags1} from "./1";
import {category as service2, createMetaTags as tags2} from "./2";
import {category as service3, createMetaTags as tags3} from "./3";
import {category as service4, createMetaTags as tags4} from "./4";
import {category as service5, createMetaTags as tags5} from "./5";
import {OG_PATH, WEBSITE_URL} from "@/content";

const categoryId = 2

export const headCategory: Category = {
    id: categoryId,
    key: 'electrical',
    name: 'Residential & Commercial Electrical Services',
    long_name: 'Residential & Commercial Electrical Services - Proelec Electrical and Air Conditioning',
    slug: 'residential-and-commercial-electrical-services-sydney',
    categoryType: 'services',
}

export const metaTags: MetaTagsProps = {
    title: "Residential & Commercial Electrical Services in Sydney | Proelec Electrical",
    description: "Proelec Electrical offers expert residential and commercial electrical services in Sydney. From installations to repairs, our licensed electricians ensure safety and quality for your home or business.",
    keywords: "residential electrical services Sydney, commercial electrical services Sydney, licensed electricians Sydney, electrical installations, electrical repairs, air-conditioning installation, lighting solutions, electrical safety inspections",
    url: `${WEBSITE_URL}/${headCategory.categoryType}/${headCategory.slug}`,
    ogImage: `${OG_PATH}c${categoryId}.jpg`,
    type: "website",
}
export const subCategoryObject = Object.fromEntries(
    Object.entries({
        category2Service1: {...service1, ...tags1(metaTags)},
        category2Service2: {...service2, ...tags2(metaTags)},
        category2Service3: {...service3, ...tags3(metaTags)},
        category2Service4: {...service4, ...tags4(metaTags)},
        category2Service5: {...service5, ...tags5(metaTags)}
    }).map(([key, value]) => [key, {...value, headCategory}])
);

const subCategories = Object.values(subCategoryObject);

export const categoryDetails: CategoryDetails = {
    ...headCategory,
    metaTags,
    order: 1,
    icon: <EmojiEventsIcon/>,
    description: ['Our services cater to the growing demand for modern electrical installations and maintenance in homes and businesses.'],
    points: [
        {
            title: 'HeadCategory5DescriptionPoint1',
            icon: Camera,
        },
        {
            title: 'HeadCategory5DescriptionPoint2',
            icon: Video,
        },
        {
            title: 'HeadCategory5DescriptionPoint3',
            icon: Palette,
        },
    ],
    videos: [],
    images: images.map((image, index) => ({
        ...image,
        alt: `${headCategory.slug}-${index + 1}`,
    })),
    subCategories,
}
